import {
  IFRAME_ID_REQUEST,
} from './actionTypes';

// Store a custom id so that the parent page can see which iframe post messages are coming from

export default function reducer(state = null, action) {
  switch (action.type) {
    case IFRAME_ID_REQUEST:
      return action.iFrameId;
    default:
      return state;
  }
}

// actions
export function updateIFrameId(iFrameId) {
  return {
    type: IFRAME_ID_REQUEST,
    iFrameId,
  };
}
